import React from 'react'
import PropTypes from 'prop-types'
import { compose, withContext, getContext, withProps } from 'recompose'

export const withContextRouter = () => compose(
  withContext(
    { router: PropTypes.object },
    ({ router }) => ({ router }),
  ),
)

export const getRouter = () => compose(
  getContext({ router: PropTypes.object }),
  withProps(({ router }) => ({
    goto: ({ href, target }) => {
      if (href && router) {
        if (target === '_blank') {
          return window.open(href, target)
        }
        return router.pushRoute(href)
      }
      return undefined
    },
  }))
)



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/withRouter.js